import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'MoveMate - Removal Company Management',
  description = 'Complete management system for removal companies. Inventory tracking, QR codes, real-time chat, driver tracking and more.',
  image = '/logo.png',
  url = 'https://movematebend.co.uk',
  type = 'website'
}) => {
  const fullTitle = title.includes('MoveMate') ? title : `${title} | MoveMate`;
  const fullImage = image.startsWith('http') ? image : `https://admin.movematebend.co.uk${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="MoveMate" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Aztrix Media Ltd." />
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;
